export function init() {
    const configurator_body = document.getElementById('js-config-v2-block');

    if (configurator_body && configurator_body.dataset.location === 'product_page') {
        import(/* webpackPrefetch: true */ './components/product_page_loader').then(
            module => new module.ProductPageLoader()
        );
    }
}